import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import VueToastr2 from 'vue-toastr-2'
import 'vue-toastr-2/dist/vue-toastr-2.min.css'
import './assets/css/micss.css'

window.toastr = require('toastr')
Vue.use(VueToastr2)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const currentUser = store.state.currentUser;

  if (requiresAuth && !currentUser) {
    next("/login");
  } else if (to.path == "/login" && currentUser) {
    next("/");
  } else {
    next();
  }
});


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
